var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"primary"},[_c('v-container',{attrs:{"fill-height":"","align":"center"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }